export default {
  placeholder: 'Haku',
  cancel: 'Peruuta',
};
